import React from "react";

type Props = {
  index: number;
  name: string;
};

const MessageName: React.FC<Props> = ({ index, name }): JSX.Element => {
  return (
    <div className={`flex flex-row ${index === 0 && "mt-10"}`}>
      <div
        className="flex flex-col w-10 h-10 rounded-lg ml-8"
        style={{ background: "#E7E9EF" }}
      />
      <div className="flex flex-col mt-2 ml-3">
        <span
          className="font-nunito text-base"
          style={{
            fontStyle: "normal",
            fontWeight: 400,
            color: "#2A2B31",
          }}
        >
          {name}
        </span>
      </div>
    </div>
  );
};

export default MessageName;
